<div [id]="sectionId">
    <ng-content select="[exl-footer-links-section-head]"></ng-content>
</div>
<ul class="link-list" [attr.aria-labelledby]="sectionId">
    <ng-content></ng-content>
</ul>